// Modification provided by Searchanise team. With any questions, contact us at feedback@searchanise.io

/*
This code translates values of the filters based on metafieds.
In the settings section, there is a filterTranslation object that contains all translation data. 

Between the filterTranslation object curly braces, you should place the name of the filter in the target language. For example:

"TEST FILTER": {},

You can add more filters following the same pattern:

"TEST FILTER 1": {},
"TEST FILTER 2": {},

Filter title you use should match the one from your admin panel. The text is case-sensitive.

Between the filter curly braces, you can place the pair of the original filter value text and translated text. For example: 

"TEST FILTER": {
    "original text": "translated text",
}

Each pair should be placed on the new line, each line should end with a comma.
The filter values are case-insensitive.
*/

// SETTINGS START

let filterTranslation = {
    "L' espèce": {
        "aluminum": "aluminum",
        "ash": "frêne",
        "birch": "merisier",
        "cedar": "cèdre",
        "composite": "composite de bois plastic",
        "douglas fir": "sapin de l'oregon",
        "fiberglass": "fibre de verre",
        "finger joint pine": "pin jointé",
        "finger joint pine poplar": "peuplier jointé",
        "flexible": "flexible",
        "hardwood": "bois dur",
        "hemlock": "pruche",
        "knotty alder": "aulne noueux",
        "knotty cedar": "cèdre noueux",
        "knotty pine": "pin noueux",
        "laminated mdf": "mdf recouvert",
        "maple": "érable",
        "maple veener": "placage d'érable",
        "mdf": "mdf",
        "metal": "métal",
        "mixed materials": "matériaux mixtes",
        "oak": "chêne",
        "oak veener": "placage chène",
        "oriented strand board": "panneau à particules orientées",
        "paint grade": "grade peinture",
        "painted finger joint pine": "pin jointé peinture",
        "painted mdf": "mdf peinturer",
        "painted poplar": "peuplier peinturer",
        "pine": "pin",
        "plastic": "plastique",
        "plywood": "contre-plaqué",
        "ployurethane": "polyuréthane",
        "poplar": "peuplier",
        "prefinished": "préfini",
        "presswood": "bois aggloméré",
        "primed finger joint pine": "pin jointé pré-peint",
        "primed finger joint poplar": "peuplier jointé pré-peint",
        "primed hemlock": "pruche pré-peint",
        "primed lacquer": "laqué prépeint sur bois",
        "primed laquer": "laqué prépeint sur bois",
        "primed lvl": "lvl pré-peint",
        "primed mdf": "mdf pré-peint",
        "pvc": "pvc",
        "raw lvl": "lvl",
        "raw mdf": "mdf",
        "softwood": "bois résineux",
        "steel": "acier",
        "vinyl": "vinyle",
        "virola": "virola",
        "walnut": "noyer",
        "white melamine": "mélamine blanche",
        "white wood": "bois blanc",
        "wood": "bois",
    },
    "Styles": {
        'modern': 'moderne',
        'traditional': 'traditionnelle',
        'vintage': 'ancienne',
        'eclectic': 'éclectique',
        'other': 'autre'
    },
  "Marque": {
    "embassy ceilings": "plafond embassy"
  }
}

// SETTINGS END. DON'T EDIT THE CODE BELOW.

document.addEventListener('Searchanise.Loaded', function() {
  (function($) {

        if ($('html').attr('lang') != 'fr') { return }

        function translateInFilter() {
            for (let filterTitle of $('.snize-product-filters-title')) {
                let formattedFilterTitle = $('.snize-filter-selected-variants-count', filterTitle).length ? $(filterTitle).text().replace($('.snize-filter-selected-variants-count', filterTitle).text(), '').trim() : $(filterTitle).text();
                if (Object.keys(filterTranslation).includes(formattedFilterTitle)) {
                    let filter = window.innerWidth > 820 ? $(filterTitle).closest('.snize-product-filters-block') : $(filterTitle).closest('.snize-product-filters-header').next();
                    let filterTranslationData = filterTranslation[formattedFilterTitle];
                    for (let filterValue of $('.snize-product-filters-list li', filter)) {
                        let filterValueText = $('.snize-product-filters-checkbox', filterValue).attr('data-se-facet-value-title');
                        if (filterValueText) {
                            let translation = filterTranslationData[filterValueText] || filterTranslationData[filterValueText.toLowerCase()];
                            if (translation) {
                                let filterCount = $('label > .needsclick .snize-filter-variant-count', filterValue).text();
                                if (!filterCount) {
                                    filterCount = '';
                                }
                                $('label > .needsclick', filterValue).text(translation);
                                if (!$('label > .needsclick > span', filterValue).length) {
                                    $('label > .needsclick', filterValue).append(`<span class="snize-filter-variant-count" aria-hidden="true">${filterCount}</span>`);
                                } else {
                                    $('label > .needsclick > span', filterValue).text(filterCount);
                                }
                            }
                        }
                    }
                }
            }
        }

        function translateInClearFilter() {
            for (let filterValue of $('.snize-clear-the-filter')) {
                for (let filter of Object.values(filterTranslation)) {
                    let translation = filter[$(filterValue).text()] || filter[$(filterValue).text().toLowerCase()];
                    if (translation) {
                        $(filterValue).text(translation);
                    }
                }
            }
        }

    
        $(document).on('Searchanise.ResultsUpdated', function(event, container) {
            translateInFilter();
            translateInClearFilter();
        });
    })(window.Searchanise.$);
});